function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.2 16.4V1.6H5.6v2.19c0 .558-.315.695-.712.298L4.4 3.6l-.488.488c-.393.393-.712.269-.712-.297V1.6H1.6v14.8h7.6zm1.2 0H12V1.6h-1.6v14.8zM0 .797C0 .357.357 0 .8 0h12a.8.8 0 0 1 .8.797v16.406c0 .44-.357.797-.8.797H.8a.8.8 0 0 1-.8-.797V.797z",
  fillRule: "evenodd"
});

var SvgNotebook = function SvgNotebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Notebook.b98752c6.svg";
export { ForwardRef as ReactComponent };